import { apiClient } from './setupApi';

export const requestGetTriggers = async () => {
  return await apiClient.get(`/logging/trigger`);
};

export const requestCreateTrigger = async (payload) => {
  const { data } = await apiClient.post(`/logging/trigger`, payload);
  return data;
};

export const requestGetTriggersWithSlug = async (slug) => {
  return await apiClient.get(`/logging/trigger/${slug}`);
};

export const requestGetHistory = async (payload) => {
  const { data } = await apiClient.get(`/logging/history`, {
    params: {
      ...payload
    }
  });
  return data;
}

export const requestCreateHistory = async (payload) => {
  const { data } = await apiClient.post(`/logging/history`, payload);
  return data;
}
